import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue, useSetRecoilState} from 'recoil';
import {Capacitor} from '@capacitor/core';
import {Share} from '@capacitor/share';

import {ToastMessage, isOpenMyPageModal, isOpenToast} from '../../../store';
import {UserInfo} from '../../../store/user';

interface Props {
  click: () => void;
}

export default function MyPageButton({click}: Props) {
  const navigator = useNavigate();
  const setIsOpenMyPageModal = useSetRecoilState(isOpenMyPageModal);
  const setToastMessage = useSetRecoilState(ToastMessage);
  const setIsOpenToast = useSetRecoilState(isOpenToast);
  const userInfo = useRecoilValue(UserInfo);

  const edit = () => {
    setIsOpenMyPageModal(false);
    navigator('/user/edit');
  };
  const share = async () => {
    await copy();
    setIsOpenMyPageModal(false);
  };

  const makeUrl = () => {
    const host =
      process.env.NODE_ENV !== 'development'
        ? 'https://knewnew.co.kr'
        : 'https://dev.knewnew.co.kr';
    return `${host}${'/community/writer/'}${userInfo.id}`;
  };

  const copy = async () => {
    if (Capacitor.getPlatform() === 'web') {
      window.navigator.clipboard.writeText(`${makeUrl()}`);
      setToastMessage('링크가 복사되었습니다.');
      setIsOpenToast(true);
    } else {
      await Share.share({
        url: `${makeUrl()}`,
      });
    }
  };
  return (
    <div className={`comment-modal-btn my-page`} onClick={() => click()}>
      <div
        className="edit-body"
        style={{background: '#fff', borderRadius: '10px'}}>
        <button
          className="profile-txt"
          style={{cursor: 'pointer'}}
          onClick={() => edit()}>
          프로필 수정
        </button>
        <hr style={{color: '#E9E7EC'}}></hr>
        <button
          className="profile-txt"
          style={{cursor: 'pointer'}}
          onClick={() => share()}>
          프로필 공유
        </button>
      </div>
      <div
        className="cancel-body"
        style={{
          marginTop: '10px',
          width: '100%',
          background: '#fff',
          borderRadius: '10px',
        }}>
        <button
          className="cancel-txt"
          style={{cursor: 'pointer', height: '50px'}}>
          취소
        </button>
      </div>
    </div>
  );
}
